// Main esbuild entrypoint for application JavaScript.
//
// This bundle is loaded alongside the legacy Propshaft-built application
// bundle. Keep imports side-effect-light until each surface has moved off the
// legacy manifest.
import {
  frontendModernizationPath,
  markEsbuildReady,
  stagedTokenSurfaces,
} from "../modules/frontend_modernization";
import {
  legacyApplicationBridgeState,
  legacyApplicationManifestOrder,
} from "../modules/legacy_manifest_order";
import {
  legacyMigrationProbeBatch,
  legacyMigrationProbeBatchRuntime,
} from "../modules/legacy_migration_probe_batch";
import { installFormsProbe } from "../modules/forms_probe";
import { installSubscriptionRecoveryProbe } from "../modules/subscription_recovery_probe";
import { installTurboMediaProbe } from "../modules/turbo_media_probe";
import { onCLS, onFCP, onINP, onLCP, onTTFB } from "web-vitals";
import { installWebVitalsReporter } from "../modules/web_vitals_reporter";

markEsbuildReady();
installFormsProbe();
installSubscriptionRecoveryProbe();
installTurboMediaProbe();
installWebVitalsReporter({ onLCP, onINP, onCLS, onFCP, onTTFB }, window, document);
void frontendModernizationPath;
void legacyApplicationBridgeState;
void legacyApplicationManifestOrder;
void legacyMigrationProbeBatch;
void legacyMigrationProbeBatchRuntime;
void stagedTokenSurfaces;
